import { useMutation, useQuery } from 'react-query'
import { createAnnotation, getAnnotations } from "../services/annotation";
import { AnnotationPostModel } from '../types/annotation';

export const useGetAnnotations = (serviceId: number | undefined) => useQuery(['annotations', serviceId], () => getAnnotations(serviceId))

export const useCreateAnnotation = () => useMutation((newAnnotation: AnnotationPostModel) => createAnnotation(newAnnotation), {

})